module.exports = __webpack_public_path__ + "img/b4.27c6f077.png";